import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { store } from './redux/store';
import { BrowserRouter } from 'react-router-dom';

import { ProvideAuth } from './auth/useFujiAuth';
import ScreenContainer from './components/screen/ScreenContainer';
import { updateAppHandle } from './redux/actions';
import { registerSW } from 'virtual:pwa-register';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { datadogLogs } from '@datadog/browser-logs';
import {
    DD_APPLICATION_ID,
    DD_CLIENT_TOKEN,
    DD_SITE,
    DD_SERVICE,
    DD_ENV,
    DISPLAY_VERSION,
    R05_API_CONFIG,
} from './utils/Constants';

if (DD_APPLICATION_ID && DD_CLIENT_TOKEN) {
    const allowedTracingUrls: string[] = [];
    try {
        if (R05_API_CONFIG.baseUrl) {
            allowedTracingUrls.push(new URL(R05_API_CONFIG.baseUrl).origin);
        }
    } catch {
        console.warn('Datadog: invalid baseUrl, allowedTracingUrls will be empty');
    }

    datadogRum.init({
        applicationId: DD_APPLICATION_ID,
        clientToken: DD_CLIENT_TOKEN,
        site: DD_SITE,
        service: DD_SERVICE,
        env: DD_ENV,
        version: DISPLAY_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,
        plugins: [reactPlugin({ router: false })],
        allowedTracingUrls,
    });
    datadogLogs.init({
        clientToken: DD_CLIENT_TOKEN,
        site: DD_SITE,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    });
}

const storeRedux = store;

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error("Root element with id 'root' not found");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
    // <React.StrictMode>

    <Provider store={storeRedux}>
        <ProvideAuth>
            <ScreenContainer>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ScreenContainer>
        </ProvideAuth>
    </Provider>,
    // </React.StrictMode>
);

// const configuration = {
//     onUpdate: (registration) => {
//         if (registration && registration.waiting) {
//             storeRedux.dispatch(updateAppHandle(registration));
//         }
//     },
//     //   onUpdate: (registration) => {
//     //       if (registration && registration.waiting) {
//     //           window.alert('New content available. Please close and restart app.') {
//     //             registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//     //             window.location.reload();
//     //         }
//     //       }
//     //     },
// };

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

const updateSW = registerSW({
    onNeedRefresh() {
        storeRedux.dispatch(updateAppHandle(updateSW));
    },
    onOfflineReady() {},
});

// serviceWorkerRegistration.register(configuration);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
